import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Customer360Service } from 'src/app/private/services/customer-360.service';
import { LeadActivityFeedItem } from '../lead-activity-feed/lead-activity-feed.component';
import {
  activityTypeLabel,
  captureChannelLabel,
} from 'src/app/utils/customer-360-labels.util';

@Component({
  selector: 'app-lead-profile-transactions',
  templateUrl: './lead-profile-transactions.component.html',
  styleUrls: ['./lead-profile-transactions.component.scss'],
})
export class LeadProfileTransactionsComponent implements OnChanges {
  @Input() leadId: number | string | null = null;
  @Input() refreshToken = 0;

  items: LeadActivityFeedItem[] = [];
  loading = false;

  constructor(private customer360: Customer360Service) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['leadId'] || changes['refreshToken']) {
      this.load();
    }
  }

  load(): void {
    if (this.leadId == null || this.leadId === '') {
      this.items = [];
      return;
    }
    this.loading = true;
    this.customer360.getCustomerTransactions(this.leadId).subscribe({
      next: (res: any) => {
        const rows = res?.rows ?? [];
        this.items = rows.map((row: any) => ({
          id: row.id,
          actorName: activityTypeLabel(row.activity_type || row.channel),
          createdAt: row.event_at || row.createdAt,
          body: this.formatBody(row),
          raw: row,
        }));
        this.loading = false;
      },
      error: () => {
        this.items = [];
        this.loading = false;
      },
    });
  }

  private formatBody(row: any): string {
    const parts: string[] = [];
    parts.push(`Via ${captureChannelLabel(row.channel)}`);
    if (row.location_name) parts.push(row.location_name);
    if (row.amount != null) {
      parts.push(`${row.currency || ''} ${row.amount}`.trim());
    }
    if (row.payment_type) parts.push(`Payment: ${row.payment_type}`);
    if (row.quantity != null) parts.push(`Qty: ${row.quantity}`);
    if (row.external_event_id) parts.push(`Ref: ${row.external_event_id}`);
    return parts.join(' · ') || 'Transaction recorded';
  }
}
